<script>
    import { apiLoading } from "../../services/store";
    import Section from "./Section.svelte";
    import Spinner from "../Spinner.svelte";
    import { fade, blur } from 'svelte/transition';

    export let data;
    export let title;

    // console.log('Dashboard data', data);

</script>

<div class="dashboard">
    {#if $apiLoading}
        <div class="loading" in:fade={{duration:200, delay:200}} out:fade={{duration:100}}>
            <p>
                <Spinner />
            </p>
        </div>
    {:else}
        <div class="dashboard-content" in:fade={{duration:200, delay:200}} out:fade={{duration:100}}>
            <h2 class="dashboard-title">{title}</h2>
            {#each data.chapters as chapter}
                <!-- {console.log('chapter', chapter)} -->
                {#if chapter.groups}
                    {#each chapter.groups as group}
                        {#each group.sections as section}
                            <Section
                                sectionData = {section}
                            />
                        {/each}
                    {/each}
                {:else}
                    {#each chapter.sections as section}
                        <Section
                            sectionData = {section}
                        />
                    {/each}
                {/if}
            {/each}
        </div>
    {/if}
</div>

<style>
    .dashboard, .loading {
        position: relative;
    }

</style>